<template>
  <v-dialog max-width="440" :value="visible" content-class="rounded-10" style="z-index: 15" @input="$emit('input', $event)">
    <v-img src="@/assets/deco/popup-top-logo.png" max-width="150" class="mx-auto" />
    <v-card class="py-2 py-md-10 px-2" color="#f7f2f7">
      <v-img src="@/assets/deco/card-top-deco.png" max-width="240px" class="mx-auto" />

      <div class="primary--text font-danjunghae text-center" style="font-size: 28px">완료되었습니다!</div>

      <v-card-title class="text-body-1 text-md-h6 text-center mx-auto font-weight-bold d-block mt-0" style="color: #545454">
        이제 촬영기로 돌아가서<br />
        다음 과정을 진행하세요!</v-card-title
      >
      <v-card-text class="warning--text pb-2 text-center">
        5초 안에 촬영기가 다음 과정(결제 화면)으로<br />
        진행되지 않으면, 이 브라우저를 완전히 닫고<br />
        다시 QR 로그인을 시도하시거나 <br />
        관리자에게 문의하세요.
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn color="#d9bddd" class="dialog_btn rounded-2" style="font-size: 20px" width="35%" depressed @click="confirmClick" large> 확인 </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    confirmClick() {
      this.$emit("close")
    },
  },
}
</script>
<style scoped>
.dialog_btn {
  border: 2px solid #dadada !important;
  font-size: 16px;
  color: #625072 !important;
}
::v-deep .v-dialog {
  box-shadow: none;
  margin-top: -20px;
}
::v-deep .v-card {
  border: 3px solid #dadada !important;
  border-radius: 10px;
}
</style>
